import React, { useState } from 'react';
import './PlayOffDownEncounter.css'
import { getCorrectListClub } from '../../variables';
import LogoClub from '../LogoClub';
import { BsFillCaretRightFill } from 'react-icons/bs';
import PlayOffDownDetails from './PlayOffDownDetails';

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

const PlayoffDownEncounter = ({
    division,
    match,
    headerLivescore,
    offOrDown,
    deploy = false,
}) => {
    const [showDetails, setShowDetails] = useState(deploy);

    // Fonction pour afficher les détails
    const handleClick = (e, isResponsive = false) => {
        e.preventDefault();

        // Si on est en mobile on veut pouvoir cliquer sur le match directement pour afficher les détails
        if (isResponsive) {
            // si on est pas sur mobile alors on veut ne pas pouvoir cliquer
            if (getWindowSize().innerWidth > 1000) {
                return false;
            }
        }
        
        setShowDetails(!showDetails);
    }

    const getClubByNameOrIdentifier = (name, num) => {
        name = name.replace(/ +(?= )/g,''); // on enlève les doubles espace / AMIENS STT  1 par exemple contient deux espaces
        return getCorrectListClub(division).find(club => club.identifier.trim() === num)  || getCorrectListClub(division).find(club => club.title.trim() === name.trim());
    }

    // Fonction pour formater la date du match
    const getDateMatch = () => {
        const value = match?.date;
        const date = new Date(value.split('/')[2] + '-' + value.split('/')[1] + '-' + value.split('/')[0]);
        const day = date.getDate();
        let month = date.toLocaleString('default', { month: 'long' });

        if (month.length > 3) {
            month = month.substring(0, 3) + '.';
        }

        return day + " " + month;
    }

    const getTimeMatch = () =>{
        return headerLivescore.heure_debut;
    }

    const getStatus = () => {
        const today = new Date().toLocaleDateString("fr-FR");

        switch (headerLivescore.status) {
            case "bientot":
                if (headerLivescore.date === today) {
                    return "bientot";
                }
                return "";
            default:
                return headerLivescore.status;
        }
    }

    const getMatchStatus = () => {
        return getStatus() + ((!match?.winner && headerLivescore.status === "termine") ? "_live" : "");
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column'}} onClick={(e)=>handleClick(e)}>
            <div className={"playoffdown_encounter_component " + getMatchStatus()} >
                {match?.day_id && (
                    <span className='playoffdown_day_responsive'>J{match?.day_id}</span>
                )}
                <span className='playoffdown_encounter_type'>
                    {offOrDown === "off" && (
                        "Playoffs"
                    )}
                    {offOrDown === "down" && (
                        "Playdowns"
                    )}
                </span>
                {/* DOMICILE */}
                <div className='playoffdown_team left'>
                    <span style={{fontWeight: match?.winner === "home" ? "bold" : "normal"}}>
                        {getClubByNameOrIdentifier(match?.domicile, match?.clubnum_1)?.title.trim()}
                    </span>
                    <LogoClub 
                        club={getClubByNameOrIdentifier(match?.domicile, match?.clubnum_1)} 
                        width='64' 
                        height='64' 
                        activateLink={false}
                    />
                </div>
                {/* INFORMATIONS */}
                <div className="playoffdown_informations">
                    {!match?.winner && (
                        <>
                            {(getStatus() === "en_cours" || getStatus() === "termine") &&(

                                <div style={{display: 'flex', alignItems: 'center', gap: 3}}>
                                    {headerLivescore.score}
                                </div>
                            )}       

                            {(getStatus() === "en_cours" ) && (
                                <div className='playoffdown_date'>
                                    En&nbsp;cours
                                </div>
                            )}
                            {(getStatus() === "termine" ) && (
                                <div className='playoffdown_date'>
                                    Terminée
                                </div>
                            )}
                               
                            {(getStatus() === "bientot" || getStatus() === "") && (
                                <>
                                    <span className="playoffdown_date">{getDateMatch()}<br/>
                                    <span>{getTimeMatch()}</span></span>
                                    {/* 
                                        Journée sous SPID
                                        On enlève 5 au jour pour correspondre à la suite logique des journées. 
                                        Au lieu de la journée 12, les playoffs / playdowns commencent à la journée 16
                                    */}
                                    <span className="playoffdown_day">
                                        {/* Journée n°{match?.day_id - 5} */}

                                        {/* Journée sous SPID */}
                                        {/* Les Quart de final/Demi-Finale/Finale durent 2 journées */}
                                        {(match?.day_id === "16" || match?.day_id === "17") && (
                                            "Quart de finale"
                                        )}
                                        {(match?.day_id === "18" || match?.day_id === "19") && (
                                            "Demi-Finale"
                                        )}
                                        {(match?.day_id === "20" || match?.day_id === "21") && (
                                            "Finale"
                                        )}
                                    </span>
                                </>
                            )}
                        </>
                    )}
                    {match?.winner && (
                        <div style={{display: 'flex', alignItems: 'center', gap: 3, whiteSpace: 'nowrap'}}>
                            <span
                                style={{fontWeight: match?.home_points > match?.away_points ? 'bold' : 'normal'}}
                                className="playoffdown_score"
                            >
                                {match?.home_points}
                            </span>
                            -
                            <span
                                style={{fontWeight: match?.home_points < match?.away_points ? 'bold' : 'normal'}}
                                className="playoffdown_score"
                            >
                                {match?.away_points}
                            </span>
                        </div>
                    )}
                </div>
                {/* EXTERIEUR */}
                <div className='playoffdown_team right' >
                    <LogoClub 
                        club={getClubByNameOrIdentifier(match?.exterieur, match?.clubnum_2)} 
                        width='64' 
                        height='64' 
                        activateLink={false}
                    />
                    <span style={{fontWeight: match?.winner === "away" ? "bold" : "normal"}}>
                        {getClubByNameOrIdentifier(match?.exterieur, match?.clubnum_2)?.title.trim()}
                    </span>
                </div>
                {/* Flèche pour afifcher les détails - seulement si on a un gagnant  */}
                {match?.winner && (
                    <BsFillCaretRightFill style={{}} className={showDetails ? "match_arrow active" : "match_arrow"} size={38} onClick={(e)=>handleClick(e)}/>
                )}
                {
                    (!match?.winner && (getStatus() === "termine") && (getWindowSize().innerWidth > 1000)) &&
                    <BsFillCaretRightFill color='blue' className={showDetails ? "match_arrow active" : "match_arrow"} size={38} onClick={(e)=>handleClick(e)} />
                }
                {/* Si le match est en train d'être livescorer alors on affiche le record */}
                {
                    (getStatus() === "en_cours") && getWindowSize().innerWidth > 1000 &&
                    <BsFillCaretRightFill color='red' className={showDetails ? "match_arrow active" : "match_arrow"} size={38} onClick={(e)=>handleClick(e)} />
                }
                {
                    (getStatus() === "bientot") && getWindowSize().innerWidth > 1000 &&
                    <span  
                        style={{
                            backgroundColor: "var(--yellow-color)",
                            top: "50%",
                            borderRadius: 5,
                            padding: "5px 10px",
                            transform: "translateY(-50%)",  
                            right: 10, 
                            position: 'absolute',
                            fontSize: 18,
                            transition: '0.2s ease-in-out all',
                        }}
                    >Aujourd'hui</span>
                    }

            </div>
            {/* Détails du match qui s'affiche quand on clique sur le match ou la flèche */}
            <PlayOffDownDetails 
                rencId={match?.renc_id}
                homeClub={getClubByNameOrIdentifier(match?.domicile, match?.clubnum_1)}
                awayClub={getClubByNameOrIdentifier(match?.exterieur, match?.clubnum_2)}
                match={match}
                deploy = {deploy}
                headerLivescore={headerLivescore}
                showDetails={showDetails}
                division={division}
                isOffDown
            />
        </div>
    );
}
 
export default PlayoffDownEncounter;